import React from "react";
import "../style/joint-replacement.css";
import Servicessidebar from "../components/servicessidebar";

const JointReplacement = () => {
    const treatments = [
        "Total Knee Replacement",
        "Total Hip Replacement",
        "Imported Implants",
        "Uni Compartmental Knee Replacement (replacing only the affected area)",
        "Knee Arthroscopy"
    ];

    return (
        <div className="jr-wrapper">
            <div className="container">
                <div className="joint-repla-je">
            <div className="jr-left">
                <h2 className="jr-title">JOINT REPLACEMENT SURGERY</h2>

                <p className="jr-text">
                    SAL Hospital’s Department of Joint Replacement is adept at conducting minimally
                    invasive, reduced tissue trauma surgery, which assures the patient of a smooth,
                    uninhibited and pain-free post-surgery recovery. We also ensure each patient retains
                    enough mobility to keep them fit and prevent cardiac and other health problems.
                </p>

                <p className="jr-text">
                    With dedicated state-of-the-art OTs supported by computer-aided navigation systems for
                    Joint Replacement and Arthroscopic Surgeries, we have been able to achieve an incredible
                    record of 0% infection rate in Knee Replacement Surgeries.
                </p>

                <p className="jr-text">
                    A multi-disciplinary team of specialist and sub-specialist doctors and surgeons, as well
                    as Ortho Physiotherapists, work in cohesion to bring the joy back into every patient’s life.
                </p>

                <ul className="jr-list">
                    {treatments.map((item, index) => (
                        <li key={index} className="jr-item">
                            <span className="jr-icon">➤</span>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>

            <div className="jr-right">
                <Servicessidebar />
            </div>
            </div>
            </div>
        </div>
    );
};

export default JointReplacement;
